export default __webpack_public_path__ + "static/5905v5907_3-341f3b22c9c65747b00efb77bd8496dd.png";